var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TeamLineUpModal',{attrs:{"selectedRoomTeam":_vm.selectedRoomTeam,"singleGame":_vm.singleGame}}),_c('div',{staticClass:"lineup",on:{"click":function($event){return _vm.callModal()}}},[_c('img',{attrs:{"src":require("../../../assets/images/edit.png"),"alt":""}}),_c('small',[_vm._v("Lineup")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }